import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { RemovePersonIcon } from "modules/icons";
import { Text, Button } from "@chakra-ui/react";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";
import { MessageThreadFragment } from "gql/graphql";
import useRemovedFromThread from "modules/hooks/use-removed-from-thread";
import { useAuth } from "modules/providers/auth-provider";

interface IProps {
  messageThread: MessageThreadFragment;
  userId: string;
}

const MessageThreadRemoveUserButton = ({ messageThread, userId }: IProps) => {
  const { me } = useAuth();
  const { openModal } = useOverlay();

  const { getCanRemoveUser } = useRemovedFromThread(messageThread);
  const canRemoveUser = getCanRemoveUser(userId);

  const onRemoveUserClicked = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      openModal({
        type: MODAL_TYPE.CONFIRM_REMOVE_USERS_GROUPS,
        id: messageThread.id,
        ids: [userId],
      });
    },
    [openModal, messageThread.id, userId],
  );

  const label = me?.id === userId ? "Leave Thread" : "Remove from Thread";

  if (!canRemoveUser || !me) {
    return null;
  }

  return (
    <Button
      variant="hover"
      p={1}
      m={1}
      leftIcon={<RemovePersonIcon fill={colors.gray40} boxSize={4} />}
      onClick={onRemoveUserClicked}
    >
      <Text color={colors.gray40} fontSize={11}>
        {label}
      </Text>
    </Button>
  );
};

export default memo(MessageThreadRemoveUserButton);
